import css from "../../css/listing/features.module.css";

import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import Row from "./Row";
import { OPTIONAL_MULTI_LIST_FIELDS } from "../../service/listing";

import checkIcon from "../../static/icons/check.png";
import uncheckIcon from "../../static/icons/cross.png";

const MultiListDetails = (props) => {
    const { listing } = props;

    let i = 1,
        checked,
        multiList,
        multiLists = [];

    for (let f of OPTIONAL_MULTI_LIST_FIELDS) {
        multiList = [];
        checked =
            listing[f.name] && Array.isArray(listing[f.name])
                ? listing[f.name]
                : [];

        for (let o of f.options) {
            multiList.push(
                <div
                    key={"ml_" + f.name + i++}
                    className={css.checkItem}
                    style={{ marginLeft: 0 }}
                >
                    <div className={css.icon}>
                        {checked.includes(o.value) ? (
                            <Image src={checkIcon} alt={o.label} />
                        ) : (
                            <Image src={uncheckIcon} alt={o.label} />
                        )}
                    </div>
                    <div className={css.label}>{o.label}</div>
                </div>
            );
        }

        multiLists.push(
            <Row
                label={f.label}
                value={<div className={css.features}>{multiList}</div>}
                key={"multi_lists_" + f.name}
            />
        );
    }

    return multiLists;
};

MultiListDetails.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default MultiListDetails;
